// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader-module--pageHeader--f508c","leftAlign":"PageHeader-module--leftAlign--c0639"};